/** Group a complete own-listing collection; state always takes precedence over type. */
export const groupOwnListings = listings => {
  const groups = {
    publishedSales: [],
    publishedBuyers: [],
    drafts: [],
    pendingApproval: [],
    closedListings: [],
    otherListings: [],
  };
  listings.forEach(listing => {
    const { state, publicData = {} } = listing.attributes;
    const key =
      state === 'published'
        ? publicData.listingType === 'mandato-compra'
          ? 'publishedBuyers'
          : 'publishedSales'
        : { draft: 'drafts', pendingApproval: 'pendingApproval', closed: 'closedListings' }[
            state
          ] || 'otherListings';
    groups[key].push(listing);
  });
  return groups;
};

/** Load every page before displaying groups, refusing incomplete or shifting inventories. */
export const queryAllOwnListings = async (sdk, queryParams) => {
  const params = { ...queryParams, page: 1, perPage: 100 };
  const first = await sdk.ownListings.query(params);
  const meta = first.data.meta;
  const validMeta = m =>
    m &&
    Number.isInteger(m.totalItems) &&
    m.totalItems >= 0 &&
    Number.isInteger(m.totalPages) &&
    m.totalPages >= 0;
  if (
    !validMeta(meta) ||
    meta.page !== 1 ||
    (meta.totalItems > 0 && meta.totalPages === 0) ||
    meta.totalPages > 100 ||
    meta.totalItems > 10000
  )
    throw new Error('Own listings pagination is incomplete');
  const data = [...first.data.data];
  const included = [...(first.data.included || [])];
  for (let page = 2; page <= meta.totalPages; page++) {
    const response = await sdk.ownListings.query({ ...params, page });
    const nextMeta = response.data.meta;
    if (
      !validMeta(nextMeta) ||
      nextMeta.totalItems !== meta.totalItems ||
      nextMeta.totalPages !== meta.totalPages ||
      nextMeta.page !== page
    ) {
      throw new Error('Own listings changed while loading; reload to try again');
    }
    data.push(...response.data.data);
    included.push(...(response.data.included || []));
  }
  if (data.length !== meta.totalItems || new Set(data.map(l => l.id.uuid)).size !== data.length) {
    throw new Error('Own listings collection is incomplete; reload to try again');
  }
  return {
    ...first,
    data: {
      ...first.data,
      data,
      included,
      meta: {
        ...meta,
        page: 1,
        perPage: Math.max(1, data.length),
        totalPages: data.length ? 1 : 0,
      },
    },
  };
};
